import React from 'react'

export const Divider = props => {
  return (
    <div
      {...props}
      className="ds-u-border-bottom--2 ds-u-margin-top--4 ds-u-margin-bottom--1 ds-u-clearfix"
    />
  )
}
